<template>
  <div class="containter-child f-col-b" @mousewheel.prevent="()=>{return false}">
    <!--    阻止冒泡-->
  </div>
</template>

<script>
export default {
  name: "search",
  watch: {},
  data() {
    return {
      cateIndex: 0,
    }
  },
  created() {
  },
  methods: {}
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/common/search.vue